<template>
    <div class="nbr-chart layout1">
        <div class="title-wrap">
            <div v-if="title" class="title-box">
                <span class="title" v-html="title"></span>
                <span class="sub-title" v-if="subTitle" v-html="subTitle"></span>
            </div>
        </div>
        <div class="empty-data" v-if="!hasData">
            <i class="iconfont icon-activities_04"></i>
            <div class="no-data" v-html="noDataDesc"></div>
        </div>
        <echart class="chart-box" v-show="hasData" :options="options" @update="update" />
    </div>
</template>

<script>
import common from './common.js';
export default {
    mixins: [common]
};
</script>

<style lang="scss">
@import '../../theme/media.scss';
.nbr-chart.layout1 {
    border-radius: 5px;
    box-shadow: 0 2px 20px 0 rgba(0, 10, 30, 0.1);
    background-color: #fff;
    display: flex;
    flex-direction: column;
    position: relative;
    .title-wrap {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        color: var(--g-primary-color);
    }
    .title-box {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        width: 100%;
    }
    .title {
        position: relative;
        line-height: 1.5;
        font-size: 20px;
        padding-bottom: 0;
    }
    .sub-title {
        font-size: 14px;
        margin-left: 20px;
        color: var(--g-primary-color);
        font-variant-ligatures: none;
        font-feature-settings: "liga" 0;
        .label {
            color: var(--g-tip-color);
        }
    }
    .empty-data {
        z-index: 1;
        position: absolute;
        max-width: 50%;
        width: 100px;
        min-height: 100px;
        left: 50%;
        top: calc(50% + 20px);
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        .iconfont {
            font-size: 64px;
            color: var(--g-tip-color);
        }
        .no-data {
            text-align: center;
            margin-top: 20px;
            font-size: 16px;
            color: var(--g-tip-color);
            width: 100%;
        }
    }
    .chart-box {
        width: 100%;
        flex: 1;
        z-index: 1;
    }
    @include media-800 {
        .title {
            font-size: 16px;
        }
    }
}
</style>
